import { Action } from '../actionTypes.js'
import {
  SIERRA_LOADING,
  SIERRA_INITIALIZED,
  SIERRA_FAILED,
  ZVA_LOADING,
  ZVA_INITIALIZED,
  ZVA_FAILED,
} from './actionTypes'
export type ChatbotState = {
  isLoading: boolean
  isInitialized?: boolean
  isFailed: boolean
  error?: any
}
const defaultState: ChatbotState = {
  isLoading: false,
  isInitialized: false,
  isFailed: false,
}
export default function reducer(
  state: ChatbotState | null | undefined = defaultState,
  action: Action
): ChatbotState {
  switch (action.type) {
    case ZVA_LOADING:
    case SIERRA_LOADING: {
      return {
        ...state,
        isLoading: true,
        isFailed: false,
      }
    }
    case ZVA_INITIALIZED:
    case SIERRA_INITIALIZED: {
      return {
        ...state,
        isLoading: false,
        isInitialized: true,
        isFailed: false,
      }
    }
    case ZVA_FAILED:
    case SIERRA_FAILED: {
      return {
        ...state,
        isLoading: false,
        isFailed: true,
        error: action.error,
      }
    }
    default: {
      return state
    }
  }
}
